import React from 'react';
import ReactDOM from 'react-dom';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import App, { ProtectedRoute } from './App';
import reportWebVitals from './reportWebVitals';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import Login from './pages/Login';
import Signup from './pages/Signup';
import RequestPasswordReset from './pages/PasswordReset/Request';
import PasswordReset from './pages/PasswordReset';
import Lite from './pages/Lite';
import LoggedIn from './components/LoggedIn';
import Dashboard from './pages/Dashboard';
import Memberships from './pages/Memberships';
import NewMembership from './pages/Memberships/NewMembership';
import MembershipDetail from './pages/Memberships/MembershipDetail';
import Patrons from './pages/Patrons';
import PatronDetail from './pages/Patrons/PatronDetail';
import Settings from './pages/Settings';
import Employees from './pages/Employees';
import Help from './pages/Help';
import MembershipSubscriptionsTable from './pages/Memberships/MembershipSubscriptionsTable';
import BenefitsView from './pages/Memberships/BenefitsView';
import WalletConfigView from './pages/Memberships/WalletConfigView'
import GiftCardConfigView from './pages/Memberships/GiftCardConfigView';
import PatronBenefitsView from './pages/Patrons/BenefitsView';
import SubscriptionsView from './pages/Patrons/SubscriptionsView';
import ProfileForm from './pages/Patrons/ProfileForm';
import { PaymentsView } from './pages/Patrons/PaymentsView';
import Integrations from './pages/Settings/Integrations';
import StripeSettings from './pages/Settings/StripeSettings';
import MailChimpSettings from './pages/Settings/MailChimpSettings';
import Billing from './pages/Settings/Billing';
import Branding from './pages/Settings/Branding';
import Locations from './pages/Settings/Locations';
import SmsSetup from './pages/Settings/SmsSetup';
import Announcements from './pages/Announcements';
import SalesAttributions from './pages/Employees/SalesAttributions';
import EmployeeDetail from './pages/Employees/EmployeeDetail';
import ManageEmployees from './pages/Employees/ManageEmployees';
import NewEmployee from './pages/Employees/NewEmployee';
import ManageBackendUsers from './pages/BackendUsers/ManageBackendUsers';
import WalletLookup from './pages/WalletLookup';
import Notify from './pages/Notify';
import StitchDashboard from './pages/StitchDashboard';
require('dotenv').config()

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/signup",
        element: <Signup />,
      },
      {
        path: "/password_reset/request",
        element: <RequestPasswordReset />,
      },
      {
        path: "/password_reset",
        element: <PasswordReset />,
      },
      {
        path: "/lite",
        element: <ProtectedRoute><Lite /></ProtectedRoute>,
      },
      {
        path: '/',
        element: <ProtectedRoute><LoggedIn /></ProtectedRoute>,
        children: [
          {
            path: '/',
            element: <Dashboard />,
          },
          {
            path: '/memberships/*',
            children: [
              {
                index: true,
                element: <Memberships />,
              },
              {
                path: 'new',
                element: <NewMembership />,
              },
              {
                path: ':id/*',
                element: <MembershipDetail />,
                children: [
                  {
                    index: true,
                    element: <MembershipSubscriptionsTable />
                  },
                  {
                    path: 'benefits',
                    element: <BenefitsView />
                  },
                  {
                    path: 'wallet',
                    element: <WalletConfigView />
                  },
                  {
                    path: 'gift-cards',
                    element: <GiftCardConfigView />
                  }
                ]
              }
            ]
          },
          {
            path: '/patrons/*',
            children: [
              {
                index: true,
                element: <Patrons />,
              },
              {
                path: ':id/*',
                element: <PatronDetail />,
                children: [
                  {
                    index: true,
                    element: <ProfileForm />
                  },
                  {
                    path: 'subscriptions',
                    element: <SubscriptionsView />
                  },
                  {
                    path: 'benefits',
                    element: <PatronBenefitsView />
                  },
                  {
                    path: 'payments',
                    element: <PaymentsView />
                  }
                ]
              },
            ]
          },
          {
            path: '/settings/*',
            element: <Settings />,
            children: [
              {
                index: true,
                element: <Integrations />,
              },
              {
                // Where Stripe sends the brewery back after Connect OAuth.
                // Without this the ?code= is never exchanged and the
                // connection silently never completes.
                path: 'integrations/stripe/connect',
                element: <StripeSettings />
              },
              {
                path: 'integrations/mailchimp',
                element: <MailChimpSettings />
              },
              {
                path: 'branding',
                element: <Branding />
              },
              {
                path: 'billing',
                element: <Billing />
              },
              {
                path: 'locations',
                element: <Locations />
              },
              {
                path: 'notifications',
                element: <ManageBackendUsers />
              },
              {
                path: 'sms',
                element: <SmsSetup />
              }
            ]
          },
          {
            path: '/employees/*',
            element: <Employees />,
            children: [
              {
                index: true,
                element: <ManageEmployees />
              },
              {
                path: 'sales_attributions',
                element: <SalesAttributions />
              },
              {
                path: 'new',
                element: <NewEmployee />
              },
              {
                path: ':id',
                element: <EmployeeDetail />
              },
            ]
          },
          {
            path: '/help',
            element: <Help />,
          },
          {
            path: '/wallet-lookup',
            element: <WalletLookup />,
          },
          {
            path: '/notify',
            element: <Notify />,
          },
          {
            path: '/stitch',
            element: <StitchDashboard />,
          },
          {
            path: '/announcements',
            element: <Announcements />,
          },
        ]
      }
    ]
  },
]);

ReactDOM.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
